import { defineMessages } from 'react-intl';

export default defineMessages({
  add: {
    id: 'PromoCode.button.add',
    description: 'Message for the price promo codes add option',
    defaultMessage: 'Add',
  },
  hide: {
    id: 'PromoCode.button.hide',
    description: 'Message for the price promo codes hide option',
    defaultMessage: 'Hide',
  },
  pricingPromoCodeTitle: {
    id: 'PromoCode.price.promoCodes.title',
    description: 'Message for the price promo codes title',
    defaultMessage: 'Promo Code',
  },
  pricingPromoCodePlaceHolder: {
    id: 'PromoCode.price.promoCodes.placeholder',
    description: 'Message for the price promo codes place holder',
    defaultMessage: 'Enter promo code',
  },
  applyButton: {
    id: 'PromoCode.button.applyButton',
    description: 'Message for the price promo codes apply option',
    defaultMessage: 'Apply',
  },
  invalidOrExpiredCoupon: {
    id: 'PromoCode.error.invalidOrExpiredCoupon',
    description: 'Message for the price promo codes apply option',
    defaultMessage: 'This code has expired.',
  },
  onlyOneCoupon: {
    id: 'PromoCode.error.onlyOneCoupon',
    description: 'Message when an attempt was made to apply more than one coupon.',
    defaultMessage: 'The code you entered can’t be combined with the code already applied.',
  },
  couponDoesNotApply: {
    id: 'PromoCode.error.couponDoesNotApply',
    description: 'Message when the coupon does not give any discount to the cart or items.',
    defaultMessage: 'This code doesn’t apply to any of the items in your cart.',
  },
  couponAlreadyUsed: {
    id: 'PromoCode.error.couponAlreadyUsed',
    description: 'Message when the coupon has already been used.',
    defaultMessage: 'It looks like this code has already been redeemed.',
  },
  couponDoesNotExist: {
    id: 'PromoCode.error.couponDoesNotExist',
    description: 'Message when the coupon does not exist.',
    defaultMessage: 'Hmm, this code doesn’t match any current promotions. Try again.',
  },
  couponHasAlreadyBeenApplied: {
    id: 'PromoCode.error.couponHasAlreadyBeenApplied',
    description: 'Message when the coupon has already been applied to a cart.',
    defaultMessage: 'This code has already been applied to your cart.',
  },
  emptyCouponCodeError: {
    id: 'PromoCode.error.emptyCouponCodeError',
    description: 'Error message when try to apply an empty promo code.',
    defaultMessage: 'Please enter a promo code.',
  },
});
